import SessionWrapper from './sessionWrapper';

const STORAGE_KEY = 'ODM_TMP';

let session = new SessionWrapper('sessionStorage', STORAGE_KEY);

export default {
    getItem(key) {
        return session.getItem(key);
    },
    
    setItem(key, value) {
        session.setItem(key, value);
    },
    
    clear() {
        session.clear();
    },

    // Just for testing!
    __setSession(s) {
        session = s;
    }
};